// 服务名称： /order/mall
import { orderFetch, userFetch } from '../fetch';

//我的订单列表
export interface IOrderListParam {
  // 当前页码
  pageNo: number;
  pageNum: number;
  // 每页条数
  pageSize: number;
  orderId: any;
  fileUrl: any;
  // 订单号
  orderCode?: string;
  // 订单状态：000：草稿，001：待报价，002：审批中，003：已报价，004：订单确认中，0041:订单已确认,
  // 005：合同生成中，006：合同待签署，0061:合同已签署,007：合同归档，008：待发货，009：待收货，010:已完成,100：已取消
  status?:
    | '000'
    | '001'
    | '002'
    | '003'
    | '004'
    | '0041'
    | '005'
    | '006'
    | '0061'
    | '007'
    | '008'
    | '009'
    | '010'
    | '100'
    | '110'
    | '120'
    | '130';

  // 下单开始时间
  createTimeBegin?: string;
  // 下单结束时间
  createTimeEnd?: string;
  // 是否是一级账号
  parentStatus?: number;
  // 用户ID
  userId?: string;
  // 客户ID
  customerCodeList?: Array<string>;
  offset?: number;
  limit?: number;
}

/**
 * 获取订单列表
 * @param data
 */
export const fetchOrderList = (data: IOrderListParam) =>
  orderFetch.post<void, void>('/order/mini/order/list', data);

/**
 * 获取合同列表
 * @param data
 */
export const fetchContractList = (data: IOrderListParam) =>
  orderFetch.post<void, void>('/orderTransaction/queryOrderContractList', data);

/**
 * 取消订单
 * @param data
 * @returns
 */
export const cancelOrder = data =>
  orderFetch.post<void, void>(`/order/mall/cancelOrder?id=${data.id}`);

/**
 * 上传合同接口
 * @param data
 * @returns
 */
export const signContract = (data: IOrderListParam) =>
  orderFetch.post<void, void>('/mall/front/signContract', data);

/**
 * 我的购物历史列表
 * @param data
 * @returns
 */
export const fetchHisShoppingList = (data: IOrderListParam) =>
  orderFetch.post<void, void>('/history/queryHisShopping', data);

/**清除我的购物历史 */
export const clearHistory = () => orderFetch.post<void, void>('/history/myClear');

/**获取常购清单列表 */
export const fetchPurchasedProductList = (data: any) =>
  orderFetch.post('/mall/front/frequentlyPurchasedProductList', data);

// 确认申请合同
export const fetchcreateOrder = data => orderFetch.post('/mall/front/createOrder', data);
// import { orderFetch, userFetch } from '../fetch';

/**
 * 询价
 */
export const fetchOrderAskPrice = data => orderFetch.post('/mall/front/askPrice', data);

/**
 * 获取订单详情
 * @param data
 */
// export const fetchOrderDetail = (id: string, mobile: any) =>
//   orderFetch.post<void, void>('/order/mall/detail', { id, mobile });
export const fetchOrderDetail = (id: string, autoError = true, mobile: any, type: any) =>
  orderFetch.post('/order/mall/detail', { id, mobile, autoErrorHandler: autoError, type });

/**
 * 确认订单时,获取验证码
 * @param data
 */
export const fetchCaptchaBySubmit = data =>
  userFetch.post('/operator/mall/confirmOrder/sendCaptcha', data);

/**
 * 确认订单
 * @param data
 */
export const confirmOrder = data => orderFetch.post('/order/confirmOrder', data);
/**
 * 确认订单时,获取验证码
 * @param data
 */
export const getOperatorCustomer = () =>
  userFetch.post<void, void>('/operator/mall/getOperatorCustomer');

export const getShipProductList = data => orderFetch.post('/order/shipProductList', data);
